import { create } from "zustand";
import { descargarDocumento } from "@/hooks/useUrlFirmada";

/**
 * Visor de documentos de toda la app (DESIGN §1, "Archivos dentro de la plataforma"). Un PDF,
 * imagen o archivo del sistema nunca se abre en otra pestaña: se muestra en `ModalViewer`, que
 * monta una sola vez `VisorDocumentoGlobal` en `App.tsx`.
 *
 * `verDocumento` se llama desde cualquier handler (no es hook). La URL puede ser pública, de
 * Storage (el visor la firma) o de Mifiel: `useUrlRecurso` la resuelve.
 */
interface VisorDocumentoState {
  url: string | null;
  titulo: string;
  abrir: (url: string, titulo?: string) => void;
  cerrar: () => void;
}

export const useVisorDocumento = create<VisorDocumentoState>((set) => ({
  url: null,
  titulo: "Documento",
  abrir: (url, titulo = "Documento") => set({ url, titulo }),
  cerrar: () => set({ url: null }),
}));

/** Office, comprimidos y texto plano: el navegador no los pinta, se descargan sin salir. */
const NO_VISIBLE = /\.(docx?|xlsx?|pptx?|csv|zip|rar|7z)$/i;

/** Abre el documento en el visor de la plataforma. Sin URL no hace nada. */
export function verDocumento(url: string | null | undefined, titulo?: string): void {
  if (!url) return;
  const ruta = url.split(/[?#]/)[0];
  if (NO_VISIBLE.test(ruta) || (titulo && NO_VISIBLE.test(titulo))) {
    void descargarDocumento(url, titulo && NO_VISIBLE.test(titulo) ? titulo : undefined);
    return;
  }
  useVisorDocumento.getState().abrir(url, titulo);
}

/** `onClick` para un `<a href>` de documento: evita la pestaña nueva y abre el visor. */
export function clicVerDocumento(url: string | null | undefined, titulo?: string) {
  return (e: { preventDefault: () => void }) => {
    if (!url) return;
    e.preventDefault();
    verDocumento(url, titulo);
  };
}
